'use strict';

export function init() {
    const concertHeaderActions = document.querySelector('.concert-header__actions');
    const contentBlocks = document.querySelector('.content-blocks');

    if (!concertHeaderActions || !contentBlocks) return;

    const lastContentBlock = contentBlocks.lastElementChild;
    if (!lastContentBlock) return;

    const checkPosition = () => {
        const lastBlockRect = lastContentBlock.getBoundingClientRect();

        if (lastBlockRect.top <= 0) {
            concertHeaderActions.classList.add('hide');
        } else {
            concertHeaderActions.classList.remove('hide');
        }
    };

    checkPosition();

    window.addEventListener('scroll', checkPosition);
}

export default { init };
